import styled from 'styled-components';
import { Accordion, AccordionSummary, styled as MUIStyled, Theme } from '@material-ui/core';
import React from 'react';

export const StyledAccordion = styled(
  ({
    isMobile,
    bookmarkMode,
    isBookmarked,
    children,
    hasNote,
    notesMode,
    mode,
    type,
    ...restProps
  }) => <Accordion {...restProps}>{children}</Accordion>
)`
  margin-bottom: ${({ mode }) => (mode === 'edit' ? '0px' : `1rem`)};
  border-radius: ${({ theme }) => theme.config.defaultBorderRadius};
  border: ${({ mode, theme }) =>
    mode === 'edit' ? '' : `1px solid ${theme.config.appbarColors.borderColor}`};
  margin-left: ${({ isMobile, bookmarkMode, isBookmarked }) =>
    isMobile && (bookmarkMode || isBookmarked) ? '2rem' : 0};
  flex: 1;
  min-height: 5rem;
  &:before {
    background-color: ${({ theme }) => theme.palette.grey['100']};
  }
  &.Mui-expanded {
    margin-top: 0;
    margin-left: ${({ isMobile, bookmarkMode, isBookmarked }) =>
      isMobile && (bookmarkMode || isBookmarked) ? '2rem' : 0};
  }
  @media print {
    display: none;
  }
`;

export const StyledAccordionSummary = styled(AccordionSummary)`
  height: 10px;
  &.Mui-expanded {
    border-bottom: ${({ theme }) => theme.config.defaultBorder(theme.palette.grey['100'])};
    height: 100%;
  }
  & .MuiAccordionSummary-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 1rem 0;
  }
`;

export const PrintMessage = styled.div`
  display: none;

  @media print {
    display: block;
    font-size: 1.3rem;
    font-style: italic;
    color: ${({ theme }) => theme.palette.grey['600']};
  }
`;

export const SolutionsWrapper = styled(({ inAccordion, ...restProps }) => <div {...restProps} />)`
  padding: ${({ inAccordion }) => (inAccordion ? '0' : '3rem 2rem')};
`;

export const SolutionsTitle = styled.div`
  font-size: ${({ theme }) => theme.typography.h3.fontSize};
  font-weight: 700;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const ExerciseDetailRelativeWrapper = MUIStyled('div')<Theme>(({ theme }) => ({
  position: 'relative',
  marginBottom: `${theme.spacing(1)}`,
}));
